function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UseCasesService from '@/apps/attributes/services/use_cases_service';
import PartitionValidationErrors from '@/apps/attributes/modules/use_cases/components/PartitionValidationErrors.vue';
import { extractCreateTables, extractReferencedTables, buildRewrites, applyRewrites, buildReferencedTablesPayload } from '@/apps/attributes/utils/sql_parser';
import tasks from '@/js/tasks';
export default {
  name: 'PartitionReviewDialog',
  components: {
    PartitionValidationErrors: PartitionValidationErrors
  },
  data: function data() {
    return {
      visible: false,
      item: null,
      detailInfo: {},
      automationId: null,
      validation: null,
      scriptText: '',
      originalScriptText: '',
      scriptLoading: false,
      detailLoading: false,
      periodLoading: false,
      periodItems: [],
      scriptError: null,
      approving: false,
      verifying: false
    };
  },
  computed: {
    isValidationOk: function isValidationOk() {
      return !!(this.validation && this.validation.ok === true);
    },
    isBusy: function isBusy() {
      return this.scriptLoading || this.detailLoading || this.periodLoading || this.approving || this.verifying;
    },
    canVerify: function canVerify() {
      return !this.scriptError && !!String(this.scriptText || '').trim();
    },
    canSubmit: function canSubmit() {
      return !this.isBusy && !this.scriptError && !!String(this.scriptText || '').trim();
    },
    scriptChanged: function scriptChanged() {
      return this.scriptText !== this.originalScriptText;
    },
    requestTitle: function requestTitle() {
      return this.item && (this.item.caso_de_uso || this.item.export_detail || this.item.business_name) || '-';
    },
    tableNameLabel: function tableNameLabel() {
      return this.item && this.item.nombre_tabla || '-';
    },
    periodsLabel: function periodsLabel() {
      var periods = this.getOriginalPeriods();
      if (periods.length) return periods.join(', ');
      var value = this.item && this.item.total_periods;
      return value === null || value === undefined || value === '' ? '-' : String(value);
    },
    periodDisplayItems: function periodDisplayItems() {
      var _this = this;
      return this.getOriginalPeriods().map(function (period) {
        return {
          raw: period,
          label: _this.formatPeriodLabel(period)
        };
      });
    },
    scriptFilename: function scriptFilename() {
      return this.getScriptFilename();
    },
    scriptLineCount: function scriptLineCount() {
      if (!this.scriptText) return 0;
      return String(this.scriptText).split(/\r\n|\r|\n/).length;
    },
    validationLabel: function validationLabel() {
      if (this.isValidationOk) return this.$t('ownership_requests.review_dialog.validation_status_ok');
      if (this.validation) return this.$t('ownership_requests.review_dialog.validation_status_error');
      return this.$t('ownership_requests.review_dialog.validation_status_unknown');
    },
    validationChipColor: function validationChipColor() {
      if (this.isValidationOk) return 'success';
      if (this.validation) return 'warning';
      return 'grey';
    },
    validationIcon: function validationIcon() {
      if (this.isValidationOk) return 'mdi-check-circle-outline';
      if (this.validation) return 'mdi-alert-circle-outline';
      return 'mdi-clock-outline';
    }
  },
  methods: {
    open: function open(item) {
      this.item = item || {};
      this.detailInfo = {};
      this.periodItems = [];
      this.automationId = this.item.automate_id || this.item.id;
      var pr = this.item.pending_review || {};
      this.validation = pr.partition_validation || this.item.partition_validation || null;
      this.scriptText = '';
      this.originalScriptText = '';
      this.scriptError = null;
      this.approving = false;
      this.visible = true;
      this.fetchDetail();
      this.fetchPeriods();
      this.fetchScript();
    },
    close: function close() {
      this.visible = false;
    },
    fetchScript: function fetchScript() {
      var _this2 = this;
      if (!this.automationId) return;
      this.scriptLoading = true;
      this.scriptError = null;
      UseCasesService.downloadAutomationScript(this.automationId).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(response) {
          var blob, rawText, createTables, referencedTables, _buildRewrites, createTableRewrites, referencedRewrites, transformedText, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                blob = response && response.data;
                if (!(blob && blob.text)) {
                  _context.n = 2;
                  break;
                }
                _context.n = 1;
                return blob.text();
              case 1:
                _t = _context.v;
                _context.n = 3;
                break;
              case 2:
                _t = '';
              case 3:
                rawText = _t;
                createTables = extractCreateTables(rawText);
                referencedTables = extractReferencedTables(rawText);
                _buildRewrites = buildRewrites(createTables, referencedTables, []), createTableRewrites = _buildRewrites.createTableRewrites, referencedRewrites = _buildRewrites.referencedRewrites;
                transformedText = applyRewrites(rawText, createTableRewrites, referencedRewrites);
                _this2.scriptText = transformedText;
                _this2.originalScriptText = transformedText;
              case 4:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (err) {
        console.error(err);
        _this2.scriptError = _this2.$t('ownership_requests.review_dialog.script_error');
      }).finally(function () {
        _this2.scriptLoading = false;
      });
    },
    fetchDetail: function fetchDetail() {
      var _this3 = this;
      if (!this.automationId) return;
      this.detailLoading = true;
      UseCasesService.getLogStatus(this.automationId).then(function (response) {
        _this3.detailInfo = response && response.data && response.data.records || {};
      }).catch(function (err) {
        console.error(err);
        _this3.detailInfo = {};
      }).finally(function () {
        _this3.detailLoading = false;
      });
    },
    fetchPeriods: function fetchPeriods() {
      var _this4 = this;
      if (!this.automationId) return;
      this.periodLoading = true;
      UseCasesService.getAutomationExecutions(this.automationId).then(function (response) {
        var data = response && response.data || response || {};
        _this4.periodItems = data.periods || [];
      }).catch(function (err) {
        console.error(err);
        _this4.periodItems = [];
      }).finally(function () {
        _this4.periodLoading = false;
      });
    },
    getScriptFilename: function getScriptFilename() {
      var outputAttrs = this.item && this.item.output_attributes || {};
      var filename = outputAttrs.script_filename || this.item.script_filename || this.item.script_name || this.item.procedure_name;
      if (filename) return /\.sql$/i.test(filename) ? filename : "".concat(filename, ".sql");
      var tableName = this.item && this.item.nombre_tabla || 'script';
      return "".concat(tableName, ".sql");
    },
    restoreOriginalScript: function restoreOriginalScript() {
      this.scriptText = this.originalScriptText;
    },
    encodeScriptText: function encodeScriptText(text) {
      return btoa(unescape(encodeURIComponent(text)));
    },
    getReferencedTablesFromScript: function getReferencedTablesFromScript() {
      var seen = new Set();
      return extractReferencedTables(this.scriptText).filter(function (ref) {
        var key = "".concat(String(ref.dataset || '').toLowerCase(), ".").concat(String(ref.table || '').toLowerCase());
        if (!ref.dataset || !ref.table || seen.has(key)) return false;
        seen.add(key);
        return true;
      }).map(function (ref) {
        return {
          dataset: ref.dataset,
          table: ref.table
        };
      });
    },
    isPeriodString: function isPeriodString(value) {
      return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value.trim());
    },
    normalizePeriods: function normalizePeriods(value) {
      var _this5 = this;
      if (!value) return [];
      if (Array.isArray(value)) {
        return value.map(function (period) {
          if (!period) return null;
          if (typeof period === 'string') return period;
          // Preferir la fecha del periodo. El `id` de un registro de ejecución es un PK
          // numérico (ej: 670), NO una fecha; solo es una fecha válida en el caso de los
          // chips del formulario de creación, donde id = 'YYYY-MM-01'.
          if (period.process_date) return period.process_date;
          if (period.period && period.period.process_date) return period.period.process_date;
          if (_this5.isPeriodString(period.id)) return period.id;
          return null;
        }).filter(Boolean);
      }
      if (typeof value === 'string') {
        try {
          var parsed = JSON.parse(value);
          var parsedPeriods = this.normalizePeriods(parsed);
          if (parsedPeriods.length) return parsedPeriods;
        } catch (err) {
          if (err && err.name !== 'SyntaxError') console.warn(err);
        }
        return value.split(',').map(function (p) {
          return p.trim();
        }).filter(Boolean);
      }
      if (value.process_date) return [value.process_date];
      return [];
    },
    formatPeriodLabel: function formatPeriodLabel(period) {
      var text = String(period || '');
      var match = /^(\d{4})-(\d{2})-01$/.exec(text);
      if (!match) return text;
      return "".concat(match[2], "/").concat(match[1]);
    },
    getOriginalPeriods: function getOriginalPeriods() {
      var pr = this.item && this.item.pending_review || {};
      var outputAttrs = this.item && this.item.output_attributes || {};
      var currentBatch = this.item && this.item.current_batch || {};
      var candidates = [this.detailInfo.periods, this.detailInfo.period, this.periodItems, this.item.periods, this.item.period, this.item.periodos, pr.periods, pr.period, outputAttrs.periods, outputAttrs.period, currentBatch.periods];
      for (var _i = 0, _candidates = candidates; _i < _candidates.length; _i++) {
        var candidate = _candidates[_i];
        var periods = this.normalizePeriods(candidate);
        if (periods.length) return periods;
      }
      return [];
    },
    handleApproveResult: function handleApproveResult(result) {
      var payload = result && result.data || result || {};
      if (payload.partition_validation) {
        this.validation = payload.partition_validation;
      }
      tasks.toast.success(this.$t('ownership_requests.review_dialog.approve_success'));
      this.$emit('approved', this.item);
      this.close();
    },
    submitEditedScript: function submitEditedScript() {
      var _this6 = this;
      if (!this.automationId) return;
      this.approving = true;
      var createTables = extractCreateTables(this.scriptText);
      var referencedTables = extractReferencedTables(this.scriptText);
      var _buildRewrites2 = buildRewrites(createTables, referencedTables, []),
        createTableRewrites = _buildRewrites2.createTableRewrites,
        referencedRewrites = _buildRewrites2.referencedRewrites;
      var finalScript = applyRewrites(this.scriptText, createTableRewrites, referencedRewrites);
      var opts = {
        script_file: this.encodeScriptText(finalScript),
        script_name: this.getScriptFilename(),
        referenced_tables: buildReferencedTablesPayload(referencedRewrites)
      };
      UseCasesService.approveAutomation(this.automationId, opts).then(this.handleApproveResult).catch(this.handleSubmitError).finally(function () {
        _this6.approving = false;
      });
    },
    onApproveClick: function onApproveClick() {
      this.submitEditedScript();
    },
    onVerifyClick: function onVerifyClick() {
      var _this7 = this;
      if (!this.automationId) return;
      this.verifying = true;
      var opts = this.scriptChanged ? {
        script_file: this.encodeScriptText(this.scriptText),
        script_name: this.getScriptFilename(),
        referenced_tables: this.getReferencedTablesFromScript()
      } : {};
      UseCasesService.revalidateAutomationPartitions(this.automationId, opts).then(function (result) {
        var pv = result && result.data && result.data.partition_validation;
        if (pv) _this7.validation = pv;
      }).catch(this.handleSubmitError).finally(function () {
        _this7.verifying = false;
      });
    },
    handleSubmitError: function handleSubmitError(err) {
      console.error(err);
      var respData = err && err.response && err.response.data || {};
      var partitionVal = respData.data && respData.data.partition_validation;
      if (partitionVal && partitionVal.ok === false && Array.isArray(partitionVal.errors)) {
        this.validation = partitionVal;
        tasks.toast.error(this.$t('create_attribute.partition_validation.blocked'));
        return;
      }
      var msg = respData.message || respData.data && respData.data.message || this.$t('error_messages.error_general');
      tasks.toast.error(String(msg), this.$t('titles.error'));
    }
  }
};